import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface GoodsPtnByMenu {
	goodsCd: string;
	goodsTourInfo: string;
	outStartDateList: string;
	wdayList: string;
	outDeprtFgList: string;
	airName: string;
	airCd: string;
	evDayCntList: string;
	dspSid: string;
	dspSidHi: string;
	goodsGbn: string;
	outCityDiviNm: string;
	minPrice: number;
	maxPrice: number;
	goodsNm: string;
	minStartDt: string;
	maxStartDt: string;
	imageThum3: string;
	goodsTp: string;
	goodsTpNm: string;
	rervCnt: number;
	webGuidConfYn: string;
	goodsBrandCd: string;
	goodsBrandNm: string;
	goodTravelYn: string;
	evProgDiviList: string;
	couponYn: string;
	couponOptTy: string;
	startFixOpenDtList: string;
	outStartWdayMonList: string;
	outStartWdayPcnt: number;
	trCompanyList: string;
	goodsFeaturesList: string;
	goodsTpointContents: string;
	goodsTmember: string;
	keyWordList: string;
	goodsPromotion: string;
	mainImgCnt: number;
	rvwAvgScore: number;
	rvwCnt: number;
	couponDiscRate: number;
	couponDiscAmt: number;
	webDisplayCls: string;
}

/** ```
 * 제휴사 메뉴별 상품 리스트 조회
 *   `/pkg/goods/partner/{ptnCode}/by-menu/{dspSid}`
 * parameter
 *   `dspSid` 지역코드
 *   `ptnCode?` 파트너사 코드
 * ```*/
const key = "useGoodsPtnByMenu";
const getPath = (dspSid: string, ptnCode: string): string =>
	`${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/goods/partner/${ptnCode}/by-menu/${dspSid}`;

/** ```
 * 제휴사 메뉴별 상품 리스트 조회
 *   `/pkg/goods/partner/{ptnCode}/by-menu/{dspSid}`
 * parameter
 *   `dspSid` 지역코드
 *   `ptnCode?` 파트너사 코드
 * ```*/
const useGoodsPtnByMenu = (
	dspSid: string,
	ptnCode: string,
	options?: Partial<UseQueryOptions<Response<GoodsPtnByMenu[]>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(dspSid, ptnCode)],
		queryFn: () => useConfigureAxios({url: getPath(dspSid, ptnCode)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useGoodsPtnByMenu;
export {getPath};
export type {GoodsPtnByMenu};
